import {  Component, Vue } from "vue-property-decorator"
import {
  financeRepeatOrderStatisticalData, financeRepeatOrderStatisticalDataExport
} from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'

import {UserModule} from "@/store/modules/user";
import commonData from "@/utils/commonData";
const projectTypeFilter =commonData.projectTypeArray

@Component({})
export default class OrderStatisticsData extends Vue {
  projectTypeFilter = projectTypeFilter //项目类型
  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  createdAt = []
  souCourseName = ''
  attendSchool = ''
  specialized = ''
  grade = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  popover4 = false
  popover5 = false
  popover6 = false
  popover7 = false
  popover8 = false
  popover9 = false
  popover10 = false
  popover11 = false
  popover12 = false
  popover13 = false
  popover14 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerName', cnFilds: '客户名称', isShow: true, id: 1 },
    { filds: 'source', cnFilds: '具体来源名称', isShow: true, id: 2 },
    { filds: 'financeOrderCode', cnFilds: '订单编号', isShow: true, id: 3 },
    { filds: 'financeOrderPrice', cnFilds: '订单金额', isShow: true, id: 4 },
    { filds: 'souCourseName', cnFilds: '项目名称', isShow: true, id: 5 },
    { filds: 'souCourseType', cnFilds: '项目类型', isShow: true, id: 6 },
    { filds: 'souCourseSchoolBegin', cnFilds: '开课时间', isShow: true, id: 7 },
    { filds: 'code', cnFilds: '撞单编号', isShow: true, id: 8 },
    { filds: 'repeatUserRealName', cnFilds: '撞单同事', isShow: true, id: 9 },
    { filds: 'aRatio', cnFilds: '撞单同事业绩分配比例', isShow: true, id: 10 },
    { filds: 'financeOrderDirectorUserRealName', cnFilds: '订单负责人', isShow: true, id: 11 },
    { filds: 'bRatio', cnFilds: '撞单负责人', isShow: true, id: 12 },
    { filds: 'messageReviewAction', cnFilds: '撞单负责人业绩分配比例', isShow: true, id: 13 },
    { filds: 'createdAt', cnFilds: '撞单创建时间', isShow: true, id: 14 },
    { filds: 'messageReviewAction', cnFilds: '审批意见', isShow: true, id: 15 },
  ]
  gradeList = [  // 年级列表
    '美制7年级/英制8年级/初一（普高）',
    '美制8年级/英制9年级/初二（普高）',
    '美制9年级/英制10年级/初三（普高）',
    '美制10年级/英制11年级/高一（普高）',
    '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
    '大学一年级',
    '大学二年级',
    '大学三年级',
    '大学四年级',
    '研究生及以上',
    '已毕业'
  ]
  customerName = ''
  customerEduCode = ''
  customerSource = ''
  financeOrderCode = ''
  caseStatus = ''
  directorUserId = ''
  souCourseTypeId = ''


  created() {
    this.getTableData()
  }

  async getTableData() {

    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.popover4 = false
    this.popover5 = false
    this.popover6 = false
    this.popover7 = false
    this.popover8 = false
    this.popover9 = false
    this.popover10 = false
    this.popover11 = false
    this.popover12 = false
    this.popover13 = false
    this.popover14 = false
    this.tableLoading = true
    const { allNum, financeRepeatOrderList } = await financeRepeatOrderStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      // dissertationType: this.dissertationType,
      // createdAt: this.createdAt && this.createdAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.createdAt[1])) : '',
      // souCourseName: this.souCourseName,
      // souCourseSchoolBegin: this.souCourseSchoolBegin && this.souCourseSchoolBegin.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[1])) : '',
      // school:this.attendSchool,
      // grade:this.grade,
      // specialized:this.specialized,
      // customerName : this.customerName,
      // customerEduCode : this.customerEduCode,
      // customerSource : this.customerSource,
      // financeOrderCode : this.financeOrderCode,
      // caseStatus : this.caseStatus,
      // directorUserId : this.directorUserId,
      // souCourseTypeId : this.souCourseTypeId
    })) as unknown as { allNum: number; financeRepeatOrderList: any[] }
    this.tableData = financeRepeatOrderList
    this.total = allNum
    this.tableLoading = false
  }

  // 导出
  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    financeRepeatOrderStatisticalDataExport(delNullProperty({
      keys,
      // dissertationType: this.dissertationType,
      // createdAt: this.createdAt && this.createdAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.createdAt[1])) : '',
      // souCourseSchoolBegin: this.souCourseSchoolBegin && this.souCourseSchoolBegin.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[1])) : '',
      // souCourseName: this.souCourseName,
      // school:this.attendSchool,
      // grade:this.grade,
      // specialized:this.specialized,
      // customerName : this.customerName,
      // customerEduCode : this.customerEduCode,
      // customerSource : this.customerSource,
      // financeOrderCode : this.financeOrderCode,
      // caseStatus : this.caseStatus,
      // directorUserId : this.directorUserId,
      // souCourseTypeId : this.souCourseTypeId
    }))
        .then(() => {
          this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        })
        .finally(() => {
          this.exportButtonDisabled = false
        })
  }

  pageChange(page: number) {
    this.page = page

    this.getTableData()
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

}
